<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12">
          <iq-card>
            <template>
                <b-row>
                    <b-col lg="12" sm="12" class="text-center mb-4">
                      <h5 class='complain-title'>{{ $t('retailerManagement.profile') }}</h5>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" sm="12" style="margin-left:50px">
                     <b-row>
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.name')}} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                      <p>{{ i18 ? formData.name_bn : formData.name_en }}</p>
                      </b-col>
                    </b-row>
                    <b-row v-if="formData.type === 1">
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.father_name')}} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                      <p>{{ i18 ? formData.father_name_bn : formData.father_name_en }}</p>
                      </b-col>
                    </b-row>
                    <b-row v-if="formData.type === 1">
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.mother_name')}} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                      <p>{{ i18 ? formData.mother_name_bn : formData.mother_name_en }}</p>
                      </b-col>
                    </b-row>
                    <b-row v-if="formData.type === 1">
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.trade_name')}} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                      <p>{{ i18 ? formData.trade_name_bn : formData.trade_name_en }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.nid')}} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                      <p>{{ $n(formData.nid, { useGrouping: false }) }}</p>
                      </b-col>
                    </b-row>
                    <b-row v-if="formData.type === 1">
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.tin_no')}} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                      <p>{{ formData.tin_no }}</p>
                      </b-col>
                    </b-row>
                     <b-row>
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.mobile_no') }} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                      <p>{{ i18 ? '০' : '0' }}{{ $n(formData.contact_no, { useGrouping: false }) }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.email')}} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                        <p>{{ formData.email }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="5" sm="12">
                        <p class="text-dark">{{$t('retailerManagement.registration_type')}} : </p>
                      </b-col>
                      <b-col lg="7" sm="12">
                        <span class="badge badge-success">
                            {{ getStoreData('registrationTypeList', formData.type) }}
                        </span>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col lg="5" sm="12">
                    <b-row>
                      <b-col>
                        <b-img @error="imageLoadError" style='width:150px;height:180px;border:1px solid gray;padding:3px' fluid :src="formData.photo"  alt="Lodding..."></b-img>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import { productionServiceBaseUrl } from '@/config/api_config'
import { core } from '@/config/pluginInit'
export default {
  props: ['id'],
  created () {
    if (this.id) {
      const tmp = this.getProfile()
       this.formData = tmp
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
        isLoad: true,
        formData: {
            user_id: '',
            type: 1,
            name_en: '',
            name_bn: '',
            father_name_en: '',
            father_name_bn: '',
            mother_name_en: '',
            mother_name_bn: '',
            registration_number: '',
            registration_date: '',
            trade_name_en: '',
            trade_name_bn: '',
            contact_no: '',
            email: '',
            nid: '',
            tin_no: ''
        }
    }
  },
  computed: {
    i18 () {
      return (this.$i18n.locale === 'bn') ? 1 : 0
    }
  },
  methods: {
    imageLoadError () {
      this.formData.photo = '/images/user.jpg'
    },
    getProfile () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
      const tmp = JSON.parse(JSON.stringify(tmpData))
      return Object.assign({}, tmp, {
          photo: productionServiceBaseUrl + 'download-attachment?file=uploads/config/dealerRetailerInfo/photooriginal/' + tmp.photo
      })
    },
    getStoreData (state, Id) {
      if (state) {
        const tmpData = this.$store.state.ProductionService.commonObj[state]
        if (typeof tmpData === 'undefined') {
          return ''
        } else {
          const data = tmpData.find(item => item.value === Id)
          if (typeof data === 'undefined') {
            return ''
          } else {
            return this.i18 ? data.text_bn : data.text_en
          }
        }
      }
    }
  }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
</style>
